import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../core/services/api.service';
import { Justification } from '../../../../Models/justification';
import { MessageService } from '../../../../core/services/message.service';
import { Location } from '@angular/common';

@Component({
    selector: 'justifications-add',
    templateUrl: './justifications-add.component.html',
    styleUrls: ['./justifications-add.component.scss']
})
/** justifications-add component*/
export class JustificationsAddComponent implements OnInit{
    id: any;
  form: FormGroup;
  submitted: boolean;
  justification: Justification;
  submitButtonText: string = 'GENERAL.LABELS.CREATE';
  isEditing: boolean;
    constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private apiService: ApiService,
    private messageService: MessageService, private location: Location) {
      this.id = this.activatedRoute.snapshot.params['id'];
    }

ngOnInit(): void {
    this.form = this.formBuilder.group({
      description: ['', Validators.required]
    });

    if (this.id) {
      this.isEditing = true;
      this.submitButtonText = 'GENERAL.LABELS.EDIT';
      this.apiService.get('api/ship/justification/' + this.id).subscribe((data: any) => {
        this.justification = data.data;
        this.form = this.formBuilder.group({
          description: [this.justification.description, Validators.required]
        });
      });

    }

  }

get controls() { return this.form.controls; }

  back() {
    this.location.back();
  }

onSubmit() {
    this.submitted = true;

    

    if (this.form.invalid) {
      return;
    }

    let model: Justification = this.form.value as Justification;
    let tem = model.description;
    if (!tem.replace(/\s/g, '').length) {
      this.messageService.error("Error", "La descripción no puede contener solo espacios.");
      return;
    }

    if(model.description.length > 200){
      this.messageService.error("Error", "La descripción no puede superar los 200 carácteres.");
      return;
    }

    if (this.isEditing) {
      model.id = this.id;
      this.apiService.put('api/ship/justification', model).subscribe(() => {
        this.messageService.success("Exito", "La justificación se ha actualizado exitosamente.");
        this.back();
      });
    }
    else {
      this.apiService.post('api/ship/justification', model).subscribe(() => {
        this.messageService.success("Exito", "La justificación se ha agregado exitosamente.");
        this.back();
      });
    }
  }
}
